import { createSelector } from "reselect";
import { APPOINTMENT_DATE_TIME } from "../consts/stepKeys";

const configSelector = state => state.config;
const bookingSelector = state => state.booking;
const waitingListSelector = state => state.waitingList;

const getState = (config, booking, waitingList) => {
  const { welcomeMessage } = config;
  let completed = false;
  if (
    booking.completedSteps.includes(APPOINTMENT_DATE_TIME) &&
    !waitingList.required &&
    waitingList.preferredTime === ""
  ) {
    completed = true;
  }
  return {
    ...booking,
    welcomeMessage,
    completed
  };
};

const bookingPortalSelector = createSelector(
  configSelector,
  bookingSelector,
  waitingListSelector,
  getState
);

export { bookingPortalSelector };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/selectors/bookingPortalSelector.js